module.exports = __webpack_public_path__ + "static/img/COC2021-25.b0ce1d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-25.jpg
// module id = 5ruI
// module chunks = 0